<template>
    <picture class="caz-image">
        <source
            v-if="image.lg_webp"
            media="(min-width: 1200px)"
            :srcset="`${image.lg_webp}, ${image.lg_2x_webp} 2x`"
            type="image/webp"
        />
        <source
            v-if="image.lg_jpg"
            media="(min-width: 1200px)"
            :srcset="`${image.lg_jpg}, ${image.lg_2x_jpg} 2x`"
            type="image/jpeg"
        />
        <source
            v-if="image.md_webp"
            media="(min-width: 992px)"
            :srcset="`${image.md_webp}, ${image.md_2x_webp} 2x`"
            type="image/webp"
        />
        <source
            v-if="image.md_jpg"
            media="(min-width: 992px)"
            :srcset="`${image.md_jpg}, ${image.md_2x_jpg} 2x`"
            type="image/jpeg"
        />
        <source
            v-if="image.sm_webp"
            media="(min-width: 768px)"
            :srcset="`${image.sm_webp}, ${image.sm_2x_webp} 2x`"
            type="image/webp"
        />
        <source
            v-if="image.sm_jpg"
            media="(min-width: 768px)"
            :srcset="`${image.sm_jpg}, ${image.sm_2x_jpg} 2x`"
            type="image/jpeg"
        />
        <source :srcset="`${image.xs_webp}, ${image.xs_2x_webp} 2x`" type="image/webp" />
        <img
            :srcset="`${image.xs_jpg}, ${image.xs_2x_jpg} 2x`"
            :alt="image.alt_tag"
            class="caz-image"
        />
    </picture>
</template>

<script>
export default {
    name: "BannerImage",
    props: {
        image: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.caz {
    &-image {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-top: -20px;
        z-index: -1;
    }

    @media (min-width: 768px) {
        &-image {
            margin-top: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/clean-air-zone/BannerImage.vue